import PropTypes from "prop-types";
import copyToClipboard from "copy-to-clipboard";
import { useParams } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useExportEngagementData } from "@/react/components/Spaces/CourseSpace/AdminSummary/hooks/useExportEngagementData";
import { usePreviewAsStudent } from "@/react/components/Spaces/CourseSpace/Shared/usePreviewAsStudent";
import { spaces } from "@/react/helpers/urlHelpers";
import { useEditLabelsModal } from "@circle-react/components/Spaces/CourseSpace/AdminSummary/EditLabelsModal";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Icon } from "@circle-react-shared/Icon";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useToast } from "@circle-react-uikit/ToastV2";

export const HeaderDropdown = ({ space, openSpaceDrawer }) => {
  const { onPreviewCourse } = usePreviewAsStudent();
  const { exportCSV } = useExportEngagementData({ space });
  const params = useParams();
  const toast = useToast();
  const copyUrlToClipboard = () => {
    copyToClipboard(
      window.location.host + spaces.show({ spaceSlug: params.spaceSlug }),
    );
    toast.success(t("courses.admin_summary.copy_url_success"));
  };
  const isSmScreen = useSmScreenMediaQuery();
  const editLabelsModal = useEditLabelsModal();

  return (
    <Dropdown
      direction="bottom-end"
      button={<IconButton name="16-menu-dots-horizontal" size={16} />}
      dataTestId="course-dropdown-actions"
    >
      {!isSmScreen && (
        <Dropdown.ItemLink onClick={onPreviewCourse}>
          <div className="flex justify-between">
            {t("courses.admin_summary.view_course")}
            <Icon type="16-arrow-top-right" size={16} className="ml-2 mt-1" />
          </div>
        </Dropdown.ItemLink>
      )}
      <Dropdown.ItemLink onClick={() => openSpaceDrawer("lock_screen")}>
        <div className="flex justify-between">
          {t("courses.admin_summary.edit_lock_screen")}
          <Icon type="16-arrow-top-right" size={16} className="ml-2 mt-1" />
        </div>
      </Dropdown.ItemLink>
      <Dropdown.Separator />
      <Dropdown.ItemLink onClick={copyUrlToClipboard}>
        {t("courses.admin_summary.copy_url")}
      </Dropdown.ItemLink>
      <Dropdown.ItemLink onClick={() => editLabelsModal.show({ space })}>
        {t("courses.admin_summary.edit_labels")}
      </Dropdown.ItemLink>
      <Dropdown.Separator />
      <Dropdown.ItemLink onClick={() => exportCSV("comments")}>
        {t("courses.admin_summary.export_comments")}
      </Dropdown.ItemLink>
      <Dropdown.ItemLink onClick={() => exportCSV("students")}>
        {t("courses.admin_summary.export_students")}
      </Dropdown.ItemLink>
      <Dropdown.ItemLink onClick={() => exportCSV("quiz_results")}>
        {t("courses.admin_summary.export_quiz_results")}
      </Dropdown.ItemLink>
    </Dropdown>
  );
};

HeaderDropdown.propTypes = {
  space: PropTypes.object.isRequired,
  openSpaceDrawer: PropTypes.func.isRequired,
};
